if (!customElements.get('mobile-menu-accordion')) {
  customElements.define(
    'mobile-menu-accordion',
    class MobileMenuAccordion extends HTMLElement {
      connectedCallback() {
        this.toggles = Array.from(this.querySelectorAll('.mobile-menu-toggle'));
        this.toggles.forEach((toggle) => {
          toggle.addEventListener('click', () => this.toggle(toggle));
        });

        this.drawer = this.closest('.menu-drawer-container');
        if (this.drawer) {
          this.drawerObserver = new MutationObserver(() => {
            if (!this.drawer.open) this.closeAll();
          });
          this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
        }
      }

      disconnectedCallback() {
        this.drawerObserver?.disconnect();
      }

      toggle(toggle) {
        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));

        toggle.setAttribute('aria-expanded', String(willOpen));
        panel?.setAttribute('aria-hidden', String(!willOpen));

        if (!willOpen && panel) {
          panel.querySelectorAll('.mobile-menu-toggle[aria-expanded="true"]').forEach((childToggle) => {
            this.setClosed(childToggle);
          });
        }
      }

      setClosed(toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        document.getElementById(toggle.getAttribute('aria-controls'))?.setAttribute('aria-hidden', 'true');
      }

      closeAll() {
        this.toggles.forEach((toggle) => this.setClosed(toggle));
      }
    }
  );
}
